import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'dibs-elements/exports/Button';

import styles from './styles/CartButton.scss';

export default function RequestPriceButton({ children, ...buttonProps }) {
    return (
        <Button className={styles.button} {...buttonProps}>
            {children}
        </Button>
    );
}

RequestPriceButton.propTypes = {
    children: PropTypes.node.isRequired,
};
